import { Component, Input } from '@angular/core';

@Component({
    selector: 'pin-three-dots',
    templateUrl: './three-dots.component.html',
    styleUrls: ['./three-dots.component.scss']
})
export class ThreeDotsComponent {
  @Input()
  customClass = '';

  @Input()
  customStyle = '';
}
